
function Card(CardProps ) {
   

    return (
        <div>
            
            <img
                alt={`${CardProps.CardProps.cardNum}`}
                src={require(`/Images/Cards/${CardProps.CardProps.cardNum}.png`)}>
            </img><br/>

            <button onClick={() => {
                //conjjole.log(HandleClick);
                CardProps.HandleClick(CardProps.index, !CardProps.CardProps.hold);
            }} >{CardProps.CardProps.hold?'Draw':'Hold'         }</button>
        </div>);

}

export default Card

